import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-manual-taxinvoice-edit',
  templateUrl: './manual-taxinvoice-edit.page.html',
  styleUrls: ['./manual-taxinvoice-edit.page.scss'],
})
export class ManualTaxinvoiceEditPage implements OnInit {

  @Input() public editselectedIndex: any;

  // @Input() public actice: any;
  public appPages = [
    {
      title: "เพิ่มข้อมูล",
      url: "/tax-invoice-edit",
      action: 1,
    },
    {
      title: "บันทึก และส่งข้อมูล",
      url: "/tax-invoice-edit",
      action: 2,
    },
  
  ];

  constructor(public router: Router, private appService: AppService) {
    console.log("new...", this.editselectedIndex);
    
  }

  ngOnInit() {
    this.appService.active.subscribe((value) => {
      console.log("value...", value);
      this.editselectedIndex = value;
    });
  }

  clickMenu(a) {
    this.appService.setActive(a);
  }
}
